import Nav from "@/components/Nav";
import About from "@/components/About";
import TrustSection from "@/components/TrustSection";
import WorkingStyle from "@/components/WorkingStyle";
import International from "@/components/International";
import Footer from "@/components/Footer";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="bg-ivory">
      <Nav />
      <div className="pt-20">
        <About />
        <TrustSection />
        <WorkingStyle />
        <International />
      </div>
      <Footer />
    </div>
  );
}
